import { render, staticRenderFns } from "./ModalManualAddTask.vue?vue&type=template&id=3cedde26&lang=pug"
import script from "./ModalManualAddTask.vue?vue&type=script&lang=js"
export * from "./ModalManualAddTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports